import { Outlet } from 'react-router';
import { LoginProvider, useLoginInfo } from '@/features/login';
import { Card, CardBody, CardHeader, Spinner } from '@heroui/react';
import { LazyMotion, AnimatePresence, domAnimation } from 'framer-motion';

const withLoginProvider = WrappedComponent => {
  const Wrapped = ({ ...rest }) => (
    <LoginProvider>
      <WrappedComponent {...rest} />
    </LoginProvider>
  );

  return Wrapped;
};

export const Layout = withLoginProvider(() => {
  const info = useLoginInfo();

  return (
    <Card className="w-full max-w-sm items-center bg-white/0">
      <CardHeader className="bg-white/30 backdrop-blur-md justify-center">
        <div className="flex flex-col items-center">
          {info.isReady ? (
            <img src={info.logo} alt={info.name} width="200"></img>
          ) : (
            <Spinner label="Loading..." />
          )}
        </div>
      </CardHeader>
      <CardBody className="bg-white/20 backdrop-blur-md p-4">
        <LazyMotion features={domAnimation}>
          <AnimatePresence initial={false} mode="wait">
            <Outlet />
          </AnimatePresence>
        </LazyMotion>
      </CardBody>
    </Card>
  );
});
